<app-side-menu>
  <div class="tf-dash-container">

    <!-- Cabeçalho -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div>
              <h1 class="page-title">
                <i class="fas fa-chart-bar me-3"></i>
                Dashboard — Multas de Trânsito
              </h1>
              <p class="page-subtitle">Análise visual de multas, status e tendências por período</p>
            </div>
            <button type="button" class="btn btn-outline-light" (click)="goToList()">
              <i class="fas fa-list me-2"></i>
              Lista de Multas
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtro de período -->
    <div class="filter-bar mb-4">
      <div class="filter-inner">
        <div class="filter-group">
          <label class="form-label mb-1">Período (IssueDate):</label>
          <div class="d-flex gap-2 align-items-center">
            <input type="date" class="form-control form-control-sm" [(ngModel)]="startDate" (change)="onPeriodChange()"/>
            <span class="text-muted">até</span>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="endDate" (change)="onPeriodChange()"/>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearPeriod()">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <app-loading [show]="isLoadingMain || isLoadingByMonth" message="Carregando dashboard..."></app-loading>

    <!-- Erro -->
    <div *ngIf="error && !(isLoadingMain || isLoadingByMonth)" class="alert alert-danger">
      <i class="fas fa-exclamation-triangle me-2"></i>{{ error }}
      <button class="btn btn-sm btn-outline-danger ms-3" (click)="loadAll()">
        <i class="fas fa-redo me-1"></i> Tentar novamente
      </button>
    </div>

    <div *ngIf="!error">

      <!-- KPI Cards via app-dash-component -->
      <app-dash-component [config]="dashConfig"></app-dash-component>

      <!-- Linha: Multas por mês -->
      <div class="row mt-4">

        <div class="col-12 mb-4">
          <div class="chart-card h-100">
            <div class="chart-card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
              <h5 class="mb-0"><i class="fas fa-calendar-alt me-2"></i>Multas por Mês</h5>
              <div class="d-flex align-items-center gap-2">
                <small class="text-muted">Meses:</small>
                <select class="form-select form-select-sm months-select" [(ngModel)]="months" (change)="onMonthsChange()">
                  <option [ngValue]="3">3</option>
                  <option [ngValue]="6">6</option>
                  <option [ngValue]="12">12</option>
                  <option [ngValue]="24">24</option>
                </select>
              </div>
            </div>
            <div class="chart-card-body">
              <div class="chart-wrapper-tall">
                <canvas id="chartByMonth"></canvas>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Linha: Top Veículos (tabela) -->
      <div class="row mt-2">
        <div class="col-12">
          <div class="chart-card">
            <div class="chart-card-header d-flex align-items-center justify-content-between">
              <h5 class="mb-0"><i class="fas fa-car me-2"></i>Top 10 Veículos com Mais Multas</h5>
              <span class="badge bg-danger">{{ topVehicles.length }} veículos</span>
            </div>
            <div class="chart-card-body">
              <div *ngIf="topVehicles.length === 0" class="empty-state">
                <i class="fas fa-car-side"></i>
                <p>Nenhum dado disponível</p>
              </div>
              <div *ngIf="topVehicles.length > 0" class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Placa</th>
                      <th class="text-center">Qtd. Multas</th>
                      <th class="text-end">Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let v of topVehicles; let i = index">
                      <td>
                        <span class="rank-badge" [class.rank-top3]="i < 3">{{ i + 1 }}</span>
                      </td>
                      <td><strong>{{ v.plateNumber || v.vehiclePlate || '—' }}</strong></td>
                      <td class="text-center">
                        <span class="count-pill">{{ v.count }}</span>
                      </td>
                      <td class="text-end text-danger fw-semibold">{{ formatCurrency(vehicleClientAmount(v)) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</app-side-menu>
